export const EVENT_LOG_DRAWER_DISCLOSURE_SEARCH_PARAM = '_open_EventLogDrawer';
export const FEED_BOTTOM_ELEM_ID = 'Feed-bottom';
export const PAGINATION_LIMIT = 10;
